import { SharedModule } from "@shared/shared.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { ArrearsEffects } from "./effects/arrears.effects";
import { DebtAnalysisWidgetConfigurationEffects } from "./effects/debt-analysis-widget-configuration.effects";

import { ArrearsWidgetComponent } from "./containers/arrears-widget/arrears-widget.component";
import { ArrearsTableComponent } from "./components/arrears-table/arrears-table.component";
import { ArrearsChartComponent } from "./components/arrears-chart/arrears-chart.component";

import * as fromArrearsReducers from "./reducers/arrears.reducers";
import * as fromDebtAnalysisWidgetConfigReducers from "./reducers/debt-analysis-widget-configuration.reducers";
import * as fromDebtAnalysisTransactionTableColumnsReducers from "./reducers/arrears-transaction-table-columns.reducer";
import * as fromDebtAnalysisTransactionTableReducers from "./reducers/arrears-transaction-table.reducer";
import * as fromDebtAnalysisDrillDownReducers from "./reducers/arrears-drilldown.reducer";

import { ArrearsHttpService } from "./services/arrears-http.service";
import { DebtAnalysisWidgetConfigurationService } from "./services/debt-analysis-widget-configuration.service";
import { DebtAnalysisWidgetConfigurationHttpService } from "./services/debt-analysis-widget-configuration.http.service";
import { ChartGroupsProvider } from "./services/chart-groups-provider";
import { ArrearsLabelsService } from "./services/arrears-labels.service";
import { ArrearsFields } from "./arrears-fields.provider";
import { ArrearsTransactionTableColumnsHttpService } from "./services/arrears-transaction-table-columns-http.service";
import { ArrearsTransactionTableColumnsService } from "./services/arrears-transaction-table-columns.service";
import { ArrearsTransactionTableService } from "./services/arrears-transaction-table.service";
import { ArrearsTransactionTableHttpService } from "./services/arrears-transaction-table-http.service";
import { ArrearsDrillDownService } from "./services/arrears-drilldown.service";
import { ArrearsWidgetAdminHandler } from "./services/arrears-widget-admin-handler";
import { DbwLayoutModule } from "app/_app_modules/dbw-layout/dbw-layout.module";
import { TableModule } from "primeng/table";

@NgModule({
  exports: [
    ArrearsWidgetComponent,
    ArrearsTableComponent,
    ArrearsChartComponent,
  ],
  declarations: [
    ArrearsWidgetComponent,
    ArrearsTableComponent,
    ArrearsChartComponent,
  ],
  providers: [
    ArrearsHttpService,
    DebtAnalysisWidgetConfigurationService,
    DebtAnalysisWidgetConfigurationHttpService,
    ChartGroupsProvider,
    ArrearsLabelsService,
    ArrearsFields,
    ArrearsTransactionTableColumnsHttpService,
    ArrearsTransactionTableColumnsService,
    ArrearsTransactionTableService,
    ArrearsTransactionTableHttpService,
    ArrearsDrillDownService,
    ArrearsWidgetAdminHandler,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TableModule,
    DbwLayoutModule,

    StoreModule.forFeature("arrears", fromArrearsReducers.reducer),
    EffectsModule.forFeature([ArrearsEffects]),

    StoreModule.forFeature(
      "debtAnalysisWidgetConfiguration",
      fromDebtAnalysisWidgetConfigReducers.reducer,
    ),
    EffectsModule.forFeature([DebtAnalysisWidgetConfigurationEffects]),

    StoreModule.forFeature(
      "debtAnalysisTransaction",
      fromDebtAnalysisTransactionTableReducers.reducer,
    ),

    StoreModule.forFeature(
      "debtAnalysisTransactionAvailableColumns",
      fromDebtAnalysisTransactionTableColumnsReducers.reducer,
    ),

    StoreModule.forFeature(
      "debtAnalysisDrillDown",
      fromDebtAnalysisDrillDownReducers.reducer,
    ),
  ],
})
export class ArrearsWidgetModule {}
